import { syncAuthCookie, userManager } from './userManager';

const RENEW_THRESHOLD_SECONDS = 30;

export const ensureFreshAuth = async (): Promise<boolean> => {
  const user = await userManager.getUser();
  if (user && (user.expires_in ?? -1) > RENEW_THRESHOLD_SECONDS) {
    syncAuthCookie(user.access_token);
    return true;
  }

  try {
    const renewed = await userManager.signinSilent();
    if (renewed) syncAuthCookie(renewed.access_token);
    return true;
  } catch {
    window.dispatchEvent(new CustomEvent('api:unauthorized'));
    return false;
  }
};
